
import React from 'react'
import ListeningTestComp from '../components/ListeningTestComp'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'


function ListeningTest() {
    
  return (
    <>
    <Navbar />
    <ListeningTestComp />
    <Footer />
    </>
  )
}

export default ListeningTest